export class ObjectNumber {
  private numericValue:number = 0;
  private powValue:number = 0;

  constructor(value:number = 0) {
    let a = value.toString(10).split('.');
    if(a.length > 1) {
      this.powValue = a[1].length;
    }
    this.numericValue = parseInt(a.join(''), 10);
  }

  private cleanup() {
    let str = this.value.toString(10);
    if(str.includes('e')) {
      let a = str.split('e+');
      let amount = parseInt(a[1], 10);

      this.powValue = amount - this.powValue;
      this.numericValue = parseFloat(a[0]);
      str = a[0];
    }

    if(str.includes('.')) {
      let numVal = Math.pow(10, this.powValue) * this.numericValue;
      let num = ObjectNumber.fromNumber(numVal);
      this.numericValue = num.value;
      this.powValue = num.factor;
    }
  }

  public static fromNumber(value:number = 0):ObjectNumber {
    return new ObjectNumber(value);
  }

  public static fromObjectNumber(value:ObjectNumber = new ObjectNumber(0)):ObjectNumber {
    return new ObjectNumber().add(value);
  }

  public expand(by:number) {
    this.powValue = this.powValue + by;
    this.numericValue = this.numericValue * Math.pow(10, by);
  }

  get value():number {
    return this.numericValue;
  }

  get factor():number {
    return this.powValue;
  }

  private match(anotherNumber:ObjectNumber):void {
    if(anotherNumber.factor < this.factor) {
      anotherNumber.expand(this.factor - anotherNumber.factor);
    }

    if(this.powValue < anotherNumber.factor) {
      this.expand(anotherNumber.factor - this.factor);
    }
  }

  public add(...value:(number|ObjectNumber)[]):this {
    for(let numberLike of value) {
      if(typeof numberLike === 'number') {
        numberLike = new ObjectNumber(numberLike);
      }

      this.match(numberLike);
      this.numericValue = this.numericValue + numberLike.value;
    }
    return this;
  }

  public subtract(...value:(number|ObjectNumber)[]):this {
    for(let numberLike of value) {
      if(typeof numberLike === 'number') {
        numberLike = new ObjectNumber(numberLike);
      }

      this.match(numberLike);

      this.numericValue = this.numericValue - numberLike.value;
    }
    return this;
  }

  public multiply(...value:(number|ObjectNumber)[]):this {
    for(let numberLike of value) {
      if(typeof(numberLike) === 'number') {
        numberLike = new ObjectNumber(numberLike);
      }

      this.numericValue = this.numericValue * numberLike.value;
      this.powValue = this.powValue + numberLike.factor;
    }

    this.cleanup();
    return this;
  }

  public divide(...value:(number|ObjectNumber)[]):this {
    for(let numberLike of value) {
      if(typeof(numberLike) === 'number') {
        numberLike = new ObjectNumber(numberLike);
      }

      if(numberLike.toNumber() === 0) {
        continue;
      }
      this.match(numberLike);
      this.numericValue = this.numericValue / numberLike.value;
      let num = ObjectNumber.fromNumber(this.numericValue);
      this.numericValue = num.value;
      this.powValue = num.factor;
    }

    return this;
  }

  public copy():ObjectNumber {
    return ObjectNumber.fromObjectNumber(this);
  }

  public toString():string {
    return (this.numericValue * Math.pow(10, this.powValue)).toString(10);
  }

  public toNumber(precision:number = 2):number {
    const isNegative = this.numericValue < 0;
    let stringValue = Math.abs(this.numericValue).toString(10);
    while (stringValue.length < this.powValue) {
      stringValue = '0' + stringValue;
    }
    let stringDecimals = stringValue.slice(stringValue.length - this.powValue);
    let floatValue = parseFloat(stringValue.slice(0, stringValue.length - this.powValue) + '.' + stringDecimals);
    let scalingValue = (1/(Math.pow(10, precision + 2)));
    let divider = Math.pow(10, precision);
    let result = Math.round((floatValue + scalingValue) * divider) / divider;
    if (isNegative) {
      result *= -1;
    }
    return result;
  }
}